import SidebarLayout from "@/components/feature/SidebarLayout";
import { useScrollReveal, getRevealClass } from "@/hooks/useScrollReveal";

const policySections = [
  {
    title: "1. 収集される個人情報",
    content: [
      "当社は、お客さまの個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行ないます。",
    ],
    list: [
      "お名前、連絡先情報（電話番号、メールアドレスなど）",
      "会社名、役職、所属部署などの職業関連情報",
      "ウェブサイトの利用履歴、Cookie、IPアドレスなどのオンライン情報",
    ],
  },
  {
    title: "2. 個人情報の利用目的",
    content: [
      "お客さまからお預かりした個人情報は、当社からのご連絡や業務のご案内やご質問に対する回答として、電子メールや資料のご送付に利用いたします。",
    ],
    list: [
      "お問い合わせや要望への対応",
      "サービスの提供や契約の履行",
      "ニュースレターやプロモーション情報の提供",
      "ウェブサイトの改善やカスタマイズ",
      "法的要件や規制の遵守",
    ],
  },
  {
    title: "3. 個人情報の第三者への提供",
    content: [
      "当社は、お客様の個人情報を第三者に提供することはありません（法的要件や規制に基づく場合を除く）。",
    ],
  },
  {
    title: "4. 個人情報の保護とセキュリティ",
    content: [
      "当社は、適切なセキュリティ対策を実施し、お客様の個人情報を保護するために合理的な措置を講じます。",
    ],
  },
  {
    title: "5. Cookieの使用",
    content: [
      "当社のウェブサイトでは、Cookieを使用する場合があります。Cookieは、ウェブサイトがお客様のブラウザに送信する小さなテキストファイルであり、お客様のコンピュータに一時的に保存されます。Cookieは、ウェブサイトの機能やパーソナライズされた体験を提供するために使用されます。",
      "当社のウェブサイトでは、以下の目的でCookieを使用することがあります。",
    ],
    list: [
      "ウェブサイトのトラフィック解析や利用状況の測定",
      "ウェブサイトのカスタマイズやパーソナライズ",
      "オンライン広告の配信や効果測定",
    ],
    afterList:
      "お客様は、ブラウザの設定を変更することで、Cookieの受け入れを拒否することができます。ただし、Cookieを無効にすると、ウェブサイトの一部の機能が制限される可能性があります。",
  },
  {
    title: "6. 個人情報の保持期間",
    content: [
      "当社は、お客様の個人情報を必要な期間だけ保管し、利用目的を達成するために必要な範囲で保持します。個人情報が不要となった場合には、適切に破棄または匿名化します。",
    ],
  },
  {
    title: "7. プライバシーポリシーの変更",
    content: [
      "当社は、必要に応じて本プライバシーポリシーを変更することがあります。変更が行われた場合には、ウェブサイト上で通知いたします。本プライバシーポリシーの最新版は常に当社のウェブサイト上でご確認いただけます。",
    ],
  },
  {
    title: "8. お問い合わせ",
    content: [
      "ご不明な点や個人情報に関するお問い合わせがある場合は、以下の連絡先までお気軽にご連絡ください。",
    ],
  },
];

export default function Privacy() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <SidebarLayout breadcrumbs={[{ label: "プライバシーポリシー" }]}>
      {/* Hero */}
      <section className="px-4 md:px-6 lg:px-10 mb-10">
        <div className="relative w-full h-[320px] sm:h-[400px] md:h-[500px] lg:h-[580px] overflow-hidden rounded-2xl bg-[#025ab0]">
          <div className="absolute inset-0 bg-gradient-to-br from-[#0366c5] via-[#025ab0] to-[#014a8c]" />
          <div ref={ref} className={`absolute inset-0 flex flex-col items-center justify-center z-10 ${getRevealClass(isVisible)}`}>
            <h1
              className="text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-wide"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              プライバシーポリシー
            </h1>
            <p
              className="text-xs sm:text-sm text-white/80 mt-2 tracking-wider"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              privacy policy
            </p>
          </div>
        </div>
      </section>

      {/* Content Card */}
      <div className="px-4 md:px-6 lg:px-10 pb-16 md:pb-24">
        <div className="bg-white rounded-2xl p-8 md:p-12 lg:p-16">
          <div className="max-w-3xl mx-auto">
            {/* Intro */}
            <div
              className="text-base md:text-lg text-gray-700 leading-[2.2] mb-12"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              <p>
                株式会社OLカンパニー（以下「当社」といいます。）は、利用者に関する情報を以下のとおり取り扱います。
              </p>
              <p className="mt-6">
                当社は、お客様の個人情報を適切に取り扱い、保護することが重要であると認識しております。本プライバシーポリシーは、当社がお客様から取得した個人情報の収集、使用、保護に関する方針を明示しています。お客様は、本プライバシーポリシーに同意することで、当社がお客様の個人情報を取り扱う方法について同意するものとします。
              </p>
            </div>

            {/* Policy Sections */}
            <div className="space-y-12">
              {policySections.map((section) => (
                <div
                  key={section.title}
                  className="border-t border-gray-100 pt-10"
                >
                  <h2
                    className="text-xl md:text-2xl font-bold text-black tracking-wide mb-5"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {section.title}
                  </h2>
                  <div
                    className="space-y-4 text-base md:text-lg text-gray-700 leading-[2.2]"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {section.content.map((paragraph, idx) => (
                      <p key={idx}>{paragraph}</p>
                    ))}
                    {section.list && (
                      <ul className="space-y-2 pl-1">
                        {section.list.map((item, idx) => (
                          <li key={idx} className="flex items-start gap-3">
                            <span className="text-gray-400 mt-2">・</span>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                    {section.afterList && <p>{section.afterList}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
}